import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "simplePage" };
const _hoisted_2 = ["src"];
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { key: 1 };
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useWhatsApp } from '@/composables/useWhatsApp';
import BulletItem from './elements/BulletItem.vue';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import MGButton from './elements/MGButton.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnableWhatsApp',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer, clearCustomer } = useCustomer();
        const { enableWhatsApp } = useWhatsApp({ whatsAppPromoCard: null, whatsAppEnableDrawer: null, whatsAppNumber: '' });
        const buttonText = ref('Enable WhatsApp');
        const done = ref(false);
        const sheet = ref(false);
        function doEnableWhatsApp() {
            enableWhatsApp();
            sheet.value = true;
            buttonText.value = 'Resend message';
            done.value = true;
        }
        onMounted(() => {
            getCustomer();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "WhatsApp AI Coach" }),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).customer
                }, null, 8, ["customer"]),
                _createElementVNode("div", _hoisted_1, [
                    _cache[2] || (_cache[2] = _createElementVNode("h1", null, "Your Personal AI Financial Assistant", -1)),
                    _createElementVNode("img", {
                        src: require('@/assets/Whatsapp.webp'),
                        class: "smallHeroImg"
                    }, null, 8, _hoisted_2),
                    (!done.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                            _createVNode(BulletItem, {
                                "bullet-image": require('@/assets/bullet-question.png'),
                                caption: "Your finance questions answered"
                            }, null, 8, ["bullet-image"]),
                            _createVNode(BulletItem, {
                                "bullet-image": require('@/assets/bullet-doc.png'),
                                caption: "Quickly add policies to your account - simply take a picture or upload a PDF"
                            }, null, 8, ["bullet-image"]),
                            _createVNode(BulletItem, {
                                "bullet-image": require('@/assets/bullet-bell.png'),
                                caption: "Get reminders when one of your policies is about to expire"
                            }, null, 8, ["bullet-image"]),
                            _createVNode(BulletItem, {
                                "bullet-image": require('@/assets/bullet-tick.png'),
                                caption: "And much more!"
                            }, null, 8, ["bullet-image"])
                        ]))
                        : _createCommentVNode("", true),
                    (done.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_4, " We have sent you a message on WhatsApp. Please open the message and tap 'I'm In'. Once you have done this, please press 'Done' below. If you did not receive the message, please press 'Resend Message'. "))
                        : _createCommentVNode("", true),
                    _createVNode(MGButton, {
                        text: buttonText.value,
                        onClick: _cache[0] || (_cache[0] = ($event) => (doEnableWhatsApp())),
                        fullWidth: true,
                        style: { "margin-top": "32px" },
                        stacked: true
                    }, null, 8, ["text"]),
                    (done.value)
                        ? (_openBlock(), _createBlock(MGButton, {
                            key: 2,
                            text: "Done",
                            onClick: _cache[1] || (_cache[1] = ($event) => { _unref(clearCustomer)(); _unref(router).back(); }),
                            fullWidth: true,
                            stacked: true
                        }))
                        : _createCommentVNode("", true)
                ])
            ], 64));
        };
    }
});
